import { HaloclineException } from '@halo/exceptions/halocline.exception'

export class Auth0InvalidAuthorizationParamsException extends HaloclineException {
    public constructor() {
        super(undefined, Auth0InvalidAuthorizationParamsException)
    }
}
